import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import useSession from 'core/hooks/use-session';
import greenCheck from 'core/assets/svg/green-check-white-bg.svg';
import { IncompleteTasksNotification } from 'common/components/notifications/incomplete-tasks-notification';
import { TransferToAgencyNotification } from 'common/components/notifications/transfer-to-agency-notification';
import { AgencyServicedByBranchNotification } from 'common/components/notifications/agency-serviced-by-branch';
import { checkIsFarmEnvironment } from 'common/helpers/environment-helpers';
import NotificationType from 'core/helpers/notifications';
import { NotificationCard } from 'core/components/notification-card';
import { useStore } from 'core/store';
import { CrossSellEligibilityNotification } from '../cross-sell-eligibility-notification';
import useStyles from './customer-notifications.styles';

const isFarmEnvironment = checkIsFarmEnvironment();

const NotificationComponentType = {
  [NotificationType.Customer.AgencyServicedByBranch]: 'tertiary'
};

const NotificationIcons = {
  [NotificationType.Customer.AgencyServicedByBranch]: greenCheck
};

const Notification = {
  [NotificationType.Customer.CrossSellEligibility]: {
    component: CrossSellEligibilityNotification,
    shouldShow: !isFarmEnvironment
  },
  [NotificationType.Customer.IncompleteTasks]: {
    component: IncompleteTasksNotification,
    shouldShow: true
  },
  [NotificationType.Customer.TransferToAgency]: {
    component: TransferToAgencyNotification,
    shouldShow: !isFarmEnvironment
  },
  [NotificationType.Customer.AgencyServicedByBranch]: {
    component: AgencyServicedByBranchNotification,
    shouldShow: !isFarmEnvironment
  }
};

const CustomerNotifications = () => {
  const {
    account: { notifications, setNotifications },
    affinityLookups
  } = useStore();
  const classes = useStyles();
  const [calledNotifications, setCalledNotifications] = useState(false);

  const { isAgency } = useSession();
  const loading = affinityLookups.loading || affinityLookups.partialLoading;

  useEffect(() => {
    // re-call set notifications once affinity lookups are loaded to render the affinity related notifications
    if (!loading && !calledNotifications) {
      setNotifications(isAgency);
      setCalledNotifications(true);
    }
  }, [affinityLookups, setNotifications, isAgency, calledNotifications, loading]);

  return (
    <Grid className={classes.container}>
      {notifications?.map((notificationType) => {
        const { component: NotificationComponent, shouldShow } = Notification[notificationType];

        if (!shouldShow) {
          return null;
        }

        return (
          <NotificationCard
            key={notificationType}
            icon={NotificationIcons[notificationType]}
            type={NotificationComponentType[notificationType]}
          >
            <NotificationComponent />
          </NotificationCard>
        );
      })}
    </Grid>
  );
};

export default observer(CustomerNotifications);
